import { print } from 'graphql';

import {
  OnTournamentsUpdateDocument,
  OnTournamentsUpdateMockDocument,
  TournamentsDocument,
  TournamentsMockDocument
} from '@swf/generated/graphql/poker/MTT/hooks';

import type { MTTDataType } from '../../types/MTT';

export const GRAPHQL_API_URL = {
  HTTP: '/api/v1-preview/mtt/graphql',
  WS: '/api/v1-preview/stream/mtt/graphql'
};

export const DOCUMENT_DATA_TYPE_MAP: {
  [K in MTTDataType]: { QUERY: string; SUBSCRIPTION: string };
} = {
  tournaments: {
    QUERY: print(TournamentsDocument),
    SUBSCRIPTION: print(OnTournamentsUpdateDocument)
  },
  mock: {
    QUERY: print(TournamentsMockDocument),
    SUBSCRIPTION: print(OnTournamentsUpdateMockDocument)
  }
};
